import React from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';
import { renderField, validate } from '../../helpers/validation.helper';

const ForgotPasswordEmailForm = props => {
    const { handleSubmit } = props;

    return (
        <div>
            <div className="container-fluid forgot-password-email-page">
                <div className="row">
                    <div className="col-lg-4 mx-auto">
                        <p className="text-white text-center">Introduceţi adresa de email pentru generarea parolei temporare</p>
                        <div className="col-lg-12">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <Field
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder="Email"
                                            component={renderField}
                                        />
                                    <div className="send-email" >
                                        <Button className="btn-cinemap-blue" type="submit">Trimite</Button>
                                    </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default reduxForm({
    form: 'forgotPasswordForm',
    validate: validate('forgotPasswordForm')
})(ForgotPasswordEmailForm)


// WEBPACK FOOTER //
// ./src/SHARED/components/forgotpassword/forgotpasswordemailForm.js